const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/ReschedulePage.tsx';
import { RouteComponentProps, useHistory } from 'react-router';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import * as React from 'react';
import { useState } from 'react';
import { actionRescheduleAppointment } from 'App/actions/appointment';
import { IconClass } from '@cistec/common_web/defs/icons';
import { SlotSelector } from './components/SlotSelector';
import { Moment } from 'moment';
import { Slot } from 'App/defs/types';
import { Page } from '../Page';
import { AppointmentTitleRow } from './components/AppointmentTitleRow';
import { AppointmentTimeRow } from './components/AppointmentTimeRow';
import { AppointmentDetailsRow } from './components/AppointmentDetailsRow';
import { Button, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import textMap from 'App/pages/appointment/translations';
import { css } from '@emotion/css';
import { AppoinmentButtonsRow } from './components/AppoinmentButtonsRow';
import { loadSchedulingSlotsForTermin } from 'App/actions/schedulingSlot';
import {
    makeSelectAvailableSlotsForTermin,
    makeSelectIsLoadingAvailableSlotsForTermin,
} from 'App/store/schedulingSlot';
import { useStructuredAppointment } from 'App/store/appointment';
import { useMadeSelector } from '@cistec/common_web/utils/store';

const cssButtonStyle = css`
    display: flex;
    justify-content: flex-end;

    & > * {
        margin-right: 0;
        margin-left: 20px;
    }
`;

interface AppointmentReschedulePageProps {}

interface IRouteParams {
    termnr: string;
}

export const ReschedulePage = (props: AppointmentReschedulePageProps & RouteComponentProps<IRouteParams>) => {
    const { termnr } = props.match.params;

    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const history = useHistory();

    const [selectedSlot, setSelectedSlot] = useState<Slot | null>();

    const slots = useMadeSelector(() => makeSelectAvailableSlotsForTermin(termnr), [termnr]);
    const slotsLoading = useMadeSelector(() => makeSelectIsLoadingAvailableSlotsForTermin(termnr), [termnr]);

    const terminNr = props.match.params.termnr ?? '';
    const { data: appointment } = useStructuredAppointment(terminNr);

    if (!appointment) return null;

    const handleSlotSelect = (slot: Slot | null) => {
        setSelectedSlot(slot);
    };

    const loadSlots = (fromDate: Moment, amountOfDaysToLoad: number) => {
        if (termnr) {
            dispatch(loadSchedulingSlotsForTermin(termnr, fromDate, amountOfDaysToLoad));
        }
    };

    const handleCancelButtonClick = () => {
        history.goBack();
    };

    const canSubmit = () => {
        return !!selectedSlot;
    };

    const handleBookAppointmentButtonClick = () => {
        if (canSubmit()) {
            dispatch(actionRescheduleAppointment(appointment, selectedSlot!, history));
        }
    };

    return (
        <Page title={formatMessage(textMap.terminUmbuchen)} iconClass={IconClass.Calendar}>
            <Grid container spacing={2}>
                <AppointmentTitleRow appointment={appointment} />
                <AppointmentTimeRow appointment={appointment} />
                <AppointmentDetailsRow appointment={appointment} />
                <Grid size={{ xs: 12 }}>
                    <Typography sx={{ color: 'primary.main' }}>{formatMessage(textMap.terminUmbuchenHelpText)}</Typography>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <SlotSelector
                        onSlotSelect={handleSlotSelect}
                        loadSlots={loadSlots}
                        slots={slots}
                        dataLoading={slotsLoading}
                    />
                </Grid>
                <AppoinmentButtonsRow className={cssButtonStyle}>
                    <Button onClick={handleCancelButtonClick}>{formatMessage(textMap.cancel)}</Button>
                    <Button
                        disabled={!canSubmit()}
                        color={'primary'}
                        variant={'contained'}
                        onClick={handleBookAppointmentButtonClick}
                    >
                        {formatMessage(textMap.requestAppointment)}
                    </Button>
                </AppoinmentButtonsRow>
            </Grid>
        </Page>
    );
};
